/* eslint-disable no-nested-ternary */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import sub from 'date-fns/sub';
import { LiaCcVisa } from 'react-icons/lia';
import { BsSim } from 'react-icons/bs';
import { useIntl } from 'react-intl';
import add from 'date-fns/add';
import {
  LuBedDouble,
  LuShieldCheck,
  LuGlobe2,
  LuBus,
  LuPlane,
} from 'react-icons/lu';

import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { useSearchParams, useNavigate } from 'react-router-dom';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import './MyBookingsPage.scss';
import AppButton from '../../shared/components/app-button/AppButton';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import {
  formatDate,
  getNewDate,
  hideHeaderMenu,
  isEmpty,
  isMobileWidth,
  showHeaderMenu,
} from '../../shared/helper-utils/appUtils';
import {
  API_DATE_FORMAT,
  SESSION_KEY_EMPTY,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import {
  getBookingsApi,
  getFlightCancellationsApi,
  getFlightReshedulesApi,
  getFlightHoldQueuesListApi,
  getFlightCancellationsQueuesApi,
} from '../../api/flightApi';
import FlightBookingList from './FlightBookingList';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import AppSelect from '../../shared/components/app-select/AppSelect';
import { getBusCancellationsApi, getBusBookingsApi } from '../../api/busApi';
import {
  getHotelBookingsApi,
  getHotelCancellationsApi,
} from '../../api/hotelApi';
import BookingsList from '../hotels/booking-details/BookingsList';
import FlightCancellationList from './FlightCancellationList';
import FlightRescheduleList from './FlightRescheduleList';
import FlightHoldQueueList from './FlightHoldQueueList';
import CreditDebitList from './CreditDebitList';
import {
  getCreditNotes,
  getDebitNotes,
  getFundTransfers,
  getFundReversals,
  getTopUpReceipts,
  getSsrHistory,
  getInsuranceBookings,
} from '../../api/profileApi';
import TopupReceiptList from './TopupReceiptList';
import AppLink from '../../shared/components/app-link/AppLink';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';

import BusBookingList from '../buses/booking-details/BusBookingList';
import BusCancellationList from '../buses/booking-details/BusCancellationsList';
import HotelCancellationList from '../hotels/booking-details/HotelCanellationsList';
import InsuranceBookingsList from './InsuranceBookingsList';
import AccountsPageHorizontalBar from '../profile/accounts/AccountsPageHorizontalBar';
import FlightCancellationQueuesList from './FlightCancellationQueuesList';
import { useAppContext } from '../../saas/AppConfigWrapper';
import { getVisaBookingsListApi } from '../online-visa/api/onlineVisaApi';
import { getEsimTransactionsApi } from '../esim/api/esimApi';
import EsimTransactionsList from '../esim/components/EsimTransactionsList/EsimTransactionsList';
import VisaBookingList from './VisaBookingList';

const TRANSACTION_TYPE = 'transactionType';

function MyBookingPage() {
  const intl = useIntl();
  const { appConfig } = useAppContext();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  // maps every tx-type value to the category (icon) it belongs to
  const TX_TYPE_CATEGORY = {
    flightBookings: 'flight',
    flightcancellationsqueues: 'flight',
    flightcancellations: 'flight',
    flightreshedules: 'flight',
    flightholdqueues: 'flight',
    hotelBookings: 'hotel',
    hotelCancellations: 'hotel',
    busBookings: 'bus',
    busCancellations: 'bus',
    insuranceBookings: 'insurance',
    visaBookings: 'visa',
    eSimbookings: 'esim',
  };

  const getTransactionTypesForCategory = (category) => {
    const options = [];

    if (category === 'flight' && appConfig?.hasFlight) {
      options.push(
        {
          label: 'Flight Cancellation Queues',
          value: 'flightcancellationsqueues',
        },
        {
          label: formattedMessage('flight_cancellation'),
          value: 'flightcancellations',
        },
        {
          label: formattedMessage('flight_reshedules'),
          value: 'flightreshedules',
        },
        { label: formattedMessage('hold_queues'), value: 'flightholdqueues' },
        // { label: formattedMessage('credit_note'), value: 'creditnotes' },
        // { label: formattedMessage('debit_note'), value: 'debitnotes' },
        // { label: formattedMessage('top_up_receipt'), value: 'topupreceipts' },
      );
    }

    if (category === 'hotel' && appConfig?.hasHotel) {
      options.push({
        label: 'Hotel Cancellations',
        value: 'hotelCancellations',
      });
    }

    if (category === 'bus' && appConfig?.hasBus) {
      options.push(
        { label: 'Bus Cancellations', value: 'busCancellations' },
        { label: 'Bus Bookings', value: 'busBookings' },
      );
    }

    if (category === 'visa' && appConfig?.hasOnlineVisa) {
      options.push({ label: 'Visa Bookings', value: 'visaBookings' });
    }

    if (category === 'esim' && appConfig?.hasEsimfast) {
      options.push({ label: 'E Sim Bookings', value: 'eSimbookings' });
    }

    return options;
  };

  const [activeCategory, setActiveCategory] = useState(
    appConfig?.hasFlight
      ? 'flight'
      : appConfig?.hasHotel
      ? 'hotel'
      : appConfig?.hasBus
      ? 'bus'
      : appConfig?.hasOnlineVisa
      ? 'visa'
      : appConfig?.hasEsimfast
      ? 'esim'
      : 'flight',
  );

  const COMMON_TX_TYPES = [
    { label: formattedMessage('credit_note'), value: 'creditnotes' },
    { label: formattedMessage('debit_note'), value: 'debitnotes' },
    { label: formattedMessage('top_up_receipt'), value: 'topupreceipts' },
  ];

  const TRANSACTION_TYPES = [
    ...getTransactionTypesForCategory(activeCategory),
    ...COMMON_TX_TYPES,
  ];

  const FULL_TX_LIST = [
    ...['flight', 'hotel', 'bus', 'visa', 'esim'].flatMap((c) =>
      getTransactionTypesForCategory(c),
    ),
    ...COMMON_TX_TYPES,
    { label: 'Flight Bookings', value: 'flightBookings' },
    { label: 'Hotel Bookings', value: 'hotelBookings' },
    { label: 'Insurance Bookings', value: 'insuranceBookings' },
    { label: 'E Sim Bookings', value: 'eSimbookings' },
    { label: 'Visa Bookings', value: 'visaBookings' },
  ];

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [alert, setAlert] = useState(undefined);
  const [bookingsList, setBookingsList] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [searchCriteria, setSearchCriteria] = useState({
    transactionType:
      isEmpty(searchParams.get(TRANSACTION_TYPE)) ||
      FULL_TX_LIST.findIndex(
        (x) => x.value === searchParams.get(TRANSACTION_TYPE),
      ) === -1
        ? appConfig?.hasFlight
          ? 'flightBookings'
          : FULL_TX_LIST[0].value
        : searchParams.get(TRANSACTION_TYPE),
    fromDate: sub(getNewDate(TODAY_DATE), { days: 8 }),
    toDate: add(getNewDate(TODAY_DATE), { days: 1 }),
  });

  const clearSessionStorage = () => {
    sessionStorage.removeItem(SESSION_KEY_EMPTY);
  };

  const getFlightBookingList = async () => {
    setIsLoading(true);
    const agentId = getUserAgentId();
    const list = await getBookingsApi(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
      agentId,
    );
    list.sort((a, b) => {
      const [aDate, aTime] = a.FlightRecord?.BookingDate?.split(' ');
      const [bDate, bTime] = b.FlightRecord?.BookingDate?.split(' ');
      if (aDate > bDate) return -1;
      if (aDate < bDate) return 1;
      const [aHours, aMinutes, aSeconds, aMilliseconds] = aTime?.split(/[:.]/);
      const [bHours, bMinutes, bSeconds, bMilliseconds] = bTime?.split(/[:.]/);
      const aTimeValue =
        parseInt(aHours, 10) * 3600000 +
        parseInt(aMinutes, 10) * 60000 +
        parseInt(aSeconds, 10) * 1000 +
        parseInt(aMilliseconds, 10);
      const bTimeValue =
        parseInt(bHours, 10) * 3600000 +
        parseInt(bMinutes, 10) * 60000 +
        parseInt(bSeconds, 10) * 1000 +
        parseInt(bMilliseconds, 10);
      return bTimeValue - aTimeValue;
    });
    list.forEach((ele) => {
      const { SectorRecord } = ele.SectorRecords;
      ele.SectorRecords.SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];
      ele.SectorRecords.SectorRecord = ele.SectorRecords.SectorRecord.sort(
        (a, b) => a.TripNumber - b.TripNumber,
      );
    });
    clearSessionStorage();
    setBookingsList(list);
    setIsLoading(false);
  };

  const getFligthCancellationsQueuesList = async () => {
    setIsLoading(true);
    const agentId = getUserAgentId();
    const response = await getFlightCancellationsQueuesApi(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
      agentId,
    );
    if (response.Root.Status === 'OK') {
      let list = response.Root.Result;
      if (list !== '') {
        list = Array.isArray(list.FlightCancellation)
          ? list.FlightCancellation
          : [list.FlightCancellation];
        setBookingsList(list);
      } else {
        setBookingsList([]);
      }
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };

  const getFligthCancellationsList = async () => {
    setIsLoading(true);
    const agentId = getUserAgentId();
    const response = await getFlightCancellationsApi(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
      agentId,
    );
    if (response.Root.Status === 'OK') {
      let list = response.Root.Result;
      if (list !== '') {
        list = Array.isArray(list.FlightCancellation)
          ? list.FlightCancellation
          : [list.FlightCancellation];
        list.sort((a, b) => {
          const [aDate, aTime] = a.TxDate?.split(' ');
          const [bDate, bTime] = b.TxDate?.split(' ');
          if (aDate > bDate) return -1;
          if (aDate < bDate) return 1;
          const [aHours, aMinutes, aSeconds, aMilliseconds] =
            aTime?.split(/[:.]/);
          const [bHours, bMinutes, bSeconds, bMilliseconds] =
            bTime?.split(/[:.]/);
          const aTimeValue =
            parseInt(aHours, 10) * 3600000 +
            parseInt(aMinutes, 10) * 60000 +
            parseInt(aSeconds, 10) * 1000 +
            parseInt(aMilliseconds, 10);
          const bTimeValue =
            parseInt(bHours, 10) * 3600000 +
            parseInt(bMinutes, 10) * 60000 +
            parseInt(bSeconds, 10) * 1000 +
            parseInt(bMilliseconds, 10);
          return bTimeValue - aTimeValue;
        });
        setBookingsList(list);
      } else {
        setBookingsList([]);
      }
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };

  const getFlightReschedulesList = async () => {
    setIsLoading(true);
    const agentId = getUserAgentId();
    const response = await getFlightReshedulesApi(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
      agentId,
    );
    if (response.Root.Status === 'OK') {
      let list = response.Root.Result.Reschedules;
      if (list !== '') {
        list = Array.isArray(list.Reschedule)
          ? list.Reschedule
          : [list.Reschedule];
        list.sort((a, b) => {
          const [aDate, aTime] = a.TxDate?.split(' ');
          const [bDate, bTime] = b.TxDate?.split(' ');
          if (aDate > bDate) return -1;
          if (aDate < bDate) return 1;
          const [aHours, aMinutes, aSeconds, aMilliseconds] =
            aTime?.split(/[:.]/);
          const [bHours, bMinutes, bSeconds, bMilliseconds] =
            bTime?.split(/[:.]/);
          const aTimeValue =
            parseInt(aHours, 10) * 3600000 +
            parseInt(aMinutes, 10) * 60000 +
            parseInt(aSeconds, 10) * 1000 +
            parseInt(aMilliseconds, 10);
          const bTimeValue =
            parseInt(bHours, 10) * 3600000 +
            parseInt(bMinutes, 10) * 60000 +
            parseInt(bSeconds, 10) * 1000 +
            parseInt(bMilliseconds, 10);
          return bTimeValue - aTimeValue;
        });
        setBookingsList(list);
      } else {
        setBookingsList([]);
      }
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };

  const getFlightHoldQueuesList = async () => {
    setIsLoading(true);
    const agentId = getUserAgentId();
    const response = await getFlightHoldQueuesListApi(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
      agentId,
    );
    if (response.Root.Status === 'OK') {
      let list = response.Root.Result;
      if (list !== '') {
        list = Array.isArray(list.FlightRecord)
          ? list.FlightRecord
          : [list.FlightRecord];
        list.sort((a, b) => {
          const [aDate, aTime] = a.BookingDate?.split(' ');
          const [bDate, bTime] = b.BookingDate?.split(' ');
          if (aDate > bDate) return -1;
          if (aDate < bDate) return 1;
          const [aHours, aMinutes, aSeconds, aMilliseconds] =
            aTime?.split(/[:.]/);
          const [bHours, bMinutes, bSeconds, bMilliseconds] =
            bTime?.split(/[:.]/);
          const aTimeValue =
            parseInt(aHours, 10) * 3600000 +
            parseInt(aMinutes, 10) * 60000 +
            parseInt(aSeconds, 10) * 1000 +
            parseInt(aMilliseconds, 10);
          const bTimeValue =
            parseInt(bHours, 10) * 3600000 +
            parseInt(bMinutes, 10) * 60000 +
            parseInt(bSeconds, 10) * 1000 +
            parseInt(bMilliseconds, 10);
          return bTimeValue - aTimeValue;
        });
        setBookingsList(list);
      } else {
        setBookingsList([]);
      }
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };

  const getCreditNoteList = async () => {
    setIsLoading(true);
    const response = await getCreditNotes(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    if (response.Root.Status === 'OK') {
      let list = response.Root.Result;
      if (list !== '') {
        list = Array.isArray(list.CreditDebitNote)
          ? list.CreditDebitNote
          : [list.CreditDebitNote];
        list.sort((a, b) => {
          const [aDate, aTime] = a.TxDate?.split(' ');
          const [bDate, bTime] = b.TxDate?.split(' ');
          if (aDate > bDate) return -1;
          if (aDate < bDate) return 1;
          const [aHours, aMinutes, aSeconds, aMilliseconds] =
            aTime?.split(/[:.]/);
          const [bHours, bMinutes, bSeconds, bMilliseconds] =
            bTime?.split(/[:.]/);
          const aTimeValue =
            parseInt(aHours, 10) * 3600000 +
            parseInt(aMinutes, 10) * 60000 +
            parseInt(aSeconds, 10) * 1000 +
            parseInt(aMilliseconds, 10);
          const bTimeValue =
            parseInt(bHours, 10) * 3600000 +
            parseInt(bMinutes, 10) * 60000 +
            parseInt(bSeconds, 10) * 1000 +
            parseInt(bMilliseconds, 10);
          return bTimeValue - aTimeValue;
        });
        setBookingsList(list);
      } else {
        setBookingsList([]);
      }
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };

  const getDebitNoteList = async () => {
    setIsLoading(true);
    const response = await getDebitNotes(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    if (response.Root.Status === 'OK') {
      let list = response.Root.Result;
      if (list !== '') {
        list = Array.isArray(list.CreditDebitNote)
          ? list.CreditDebitNote
          : [list.CreditDebitNote];
        list.sort((a, b) => {
          const [aDate, aTime] = a.TxDate?.split(' ');
          const [bDate, bTime] = b.TxDate?.split(' ');
          if (aDate > bDate) return -1;
          if (aDate < bDate) return 1;
          const [aHours, aMinutes, aSeconds, aMilliseconds] =
            aTime?.split(/[:.]/);
          const [bHours, bMinutes, bSeconds, bMilliseconds] =
            bTime?.split(/[:.]/);
          const aTimeValue =
            parseInt(aHours, 10) * 3600000 +
            parseInt(aMinutes, 10) * 60000 +
            parseInt(aSeconds, 10) * 1000 +
            parseInt(aMilliseconds, 10);
          const bTimeValue =
            parseInt(bHours, 10) * 3600000 +
            parseInt(bMinutes, 10) * 60000 +
            parseInt(bSeconds, 10) * 1000 +
            parseInt(bMilliseconds, 10);
          return bTimeValue - aTimeValue;
        });
        setBookingsList(list);
      } else {
        setBookingsList([]);
      }
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };

  const getSsrHistoryList = async () => {
    setIsLoading(true);
    const response = await getSsrHistory(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    setBookingsList([]);
    clearSessionStorage();
    setIsLoading(false);
  };

  const getFundTransfersList = async () => {
    setIsLoading(true);
    const response = await getFundTransfers(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    if (response.Root.Status === 'OK') {
      let list = response.Root.Result;
      if (list !== '') {
        list = Array.isArray(list.CreditDebitNote)
          ? list.CreditDebitNote
          : [list.CreditDebitNote];
        list.sort((a, b) => {
          const [aDate, aTime] = a.TxDate?.split(' ');
          const [bDate, bTime] = b.TxDate?.split(' ');
          if (aDate > bDate) return -1;
          if (aDate < bDate) return 1;
          const [aHours, aMinutes, aSeconds, aMilliseconds] =
            aTime?.split(/[:.]/);
          const [bHours, bMinutes, bSeconds, bMilliseconds] =
            bTime?.split(/[:.]/);
          const aTimeValue =
            parseInt(aHours, 10) * 3600000 +
            parseInt(aMinutes, 10) * 60000 +
            parseInt(aSeconds, 10) * 1000 +
            parseInt(aMilliseconds, 10);
          const bTimeValue =
            parseInt(bHours, 10) * 3600000 +
            parseInt(bMinutes, 10) * 60000 +
            parseInt(bSeconds, 10) * 1000 +
            parseInt(bMilliseconds, 10);
          return bTimeValue - aTimeValue;
        });
        setBookingsList(list);
      } else {
        setBookingsList([]);
      }
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };

  const getFundReversalsList = async () => {
    setIsLoading(true);
    const response = await getFundReversals(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    if (response?.Root?.Status === 'OK') {
      let list = response.Root.Result;
      if (list !== '') {
        list = Array.isArray(list.CreditDebitNote)
          ? list.CreditDebitNote
          : [list.CreditDebitNote];
        list.sort((a, b) => {
          const [aDate, aTime] = a.TxDate?.split(' ');
          const [bDate, bTime] = b.TxDate?.split(' ');
          if (aDate > bDate) return -1;
          if (aDate < bDate) return 1;
          const [aHours, aMinutes, aSeconds, aMilliseconds] =
            aTime?.split(/[:.]/);
          const [bHours, bMinutes, bSeconds, bMilliseconds] =
            bTime?.split(/[:.]/);
          const aTimeValue =
            parseInt(aHours, 10) * 3600000 +
            parseInt(aMinutes, 10) * 60000 +
            parseInt(aSeconds, 10) * 1000 +
            parseInt(aMilliseconds, 10);
          const bTimeValue =
            parseInt(bHours, 10) * 3600000 +
            parseInt(bMinutes, 10) * 60000 +
            parseInt(bSeconds, 10) * 1000 +
            parseInt(bMilliseconds, 10);
          return bTimeValue - aTimeValue;
        });
        setBookingsList(list);
      } else {
        setBookingsList([]);
      }
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };

  const getTopupReceiptsList = async () => {
    setIsLoading(true);
    const response = await getTopUpReceipts(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    if (response.Root.Status === 'OK') {
      let list = response.Root.Result;
      if (list !== '') {
        list = Array.isArray(list.Receipt) ? list.Receipt : [list.Receipt];
        list.sort((a, b) => {
          const [aDate, aTime] = a.TxDate?.split(' ');
          const [bDate, bTime] = b.TxDate?.split(' ');
          if (aDate > bDate) return -1;
          if (aDate < bDate) return 1;
          const [aHours, aMinutes, aSeconds, aMilliseconds] =
            aTime?.split(/[:.]/);
          const [bHours, bMinutes, bSeconds, bMilliseconds] =
            bTime?.split(/[:.]/);
          const aTimeValue =
            parseInt(aHours, 10) * 3600000 +
            parseInt(aMinutes, 10) * 60000 +
            parseInt(aSeconds, 10) * 1000 +
            parseInt(aMilliseconds, 10);
          const bTimeValue =
            parseInt(bHours, 10) * 3600000 +
            parseInt(bMinutes, 10) * 60000 +
            parseInt(bSeconds, 10) * 1000 +
            parseInt(bMilliseconds, 10);
          return bTimeValue - aTimeValue;
        });
        setBookingsList(list);
      } else {
        setBookingsList([]);
      }
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };

  const getHotelBookingList = async () => {
    setIsLoading(true);
    const response = await getHotelBookingsApi(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    if (response?.Root?.Status === 'OK') {
      let list = response.Root?.Result?.HotelInvoice || [];
      list = Array.isArray(list) ? list : [list];
      list.sort((a, b) => {
        const [aDate, aTime] = a.tx_date?.split(' ');
        const [bDate, bTime] = b.tx_date?.split(' ');
        if (aDate > bDate) return -1;
        if (aDate < bDate) return 1;
        const [aHours, aMinutes, aSeconds, aMilliseconds] =
          aTime?.split(/[:.]/);
        const [bHours, bMinutes, bSeconds, bMilliseconds] =
          bTime?.split(/[:.]/);
        const aTimeValue =
          parseInt(aHours, 10) * 3600000 +
          parseInt(aMinutes, 10) * 60000 +
          parseInt(aSeconds, 10) * 1000 +
          parseInt(aMilliseconds, 10);
        const bTimeValue =
          parseInt(bHours, 10) * 3600000 +
          parseInt(bMinutes, 10) * 60000 +
          parseInt(bSeconds, 10) * 1000 +
          parseInt(bMilliseconds, 10);
        return bTimeValue - aTimeValue;
      });
      setBookingsList(list);
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };
  const getHotelCancellationList = async () => {
    setIsLoading(true);
    const response = await getHotelCancellationsApi(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    if (response?.Root?.Status === 'OK') {
      let list = response.Root?.Result?.HotelCancellation || [];
      list = Array.isArray(list) ? list : [list];
      list.sort((a, b) => {
        const [aDate, aTime] = a.TxDate?.split(' ');
        const [bDate, bTime] = b.TxDate?.split(' ');
        if (aDate > bDate) return -1;
        if (aDate < bDate) return 1;
        const [aHours, aMinutes, aSeconds, aMilliseconds] =
          aTime?.split(/[:.]/);
        const [bHours, bMinutes, bSeconds, bMilliseconds] =
          bTime?.split(/[:.]/);
        const aTimeValue =
          parseInt(aHours, 10) * 3600000 +
          parseInt(aMinutes, 10) * 60000 +
          parseInt(aSeconds, 10) * 1000 +
          parseInt(aMilliseconds, 10);
        const bTimeValue =
          parseInt(bHours, 10) * 3600000 +
          parseInt(bMinutes, 10) * 60000 +
          parseInt(bSeconds, 10) * 1000 +
          parseInt(bMilliseconds, 10);
        return bTimeValue - aTimeValue;
      });
      setBookingsList(list);
    } else {
      setBookingsList([]);
      setAlert({
        variant: 'error',
        title: 'Hotel Cancellations',
        description: response?.Root?.Message,
      });
    }
    clearSessionStorage();
    setIsLoading(false);
  };

  const getBusBookingList = async () => {
    setIsLoading(true);
    const response = await getBusBookingsApi(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    if (response?.Root?.Status === 'OK') {
      const { BusInvoice } = response.Root.Result;
      setBookingsList(Array.isArray(BusInvoice) ? BusInvoice : [BusInvoice]);
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };
  const getBusCancellationList = async () => {
    setIsLoading(true);
    const response = await getBusCancellationsApi(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    if (response?.Root?.Status === 'OK') {
      let data = response.Root?.Result?.BusCancellation || [];
      data = Array.isArray(data) ? data : [data];
      setBookingsList(data);
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };
  const getInsuranceBookingsList = async () => {
    setIsLoading(true);
    const response = await getInsuranceBookings(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    if (response?.Root?.Status === 'OK') {
      let data =
        response.Root?.Result?.TIOfflineInvoices?.TravelInsuranceInvoice;
      if (data) {
        data = Array.isArray(data) ? data : [data];
        setBookingsList(data);
      } else {
        setBookingsList([]);
        setAlert({
          variant: 'error',
          title: 'Insurance Bookings',
          description: 'No Bookings Found',
        });
      }
    } else {
      setBookingsList([]);
      setAlert({
        variant: 'error',
        title: 'Insurance Bookings',
        description: response?.Root?.Message,
      });
    }
    clearSessionStorage();
    setIsLoading(false);
  };

  const getVisaBookingsList = async () => {
    setIsLoading(true);
    const data = await getVisaBookingsListApi(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    if (data && data.length > 0) {
      let list = data;
      list = Array.isArray(list) ? list : [list];
      list.sort((a, b) => {
        const [aDate, aTime] = a.created_on?.split(' ');
        const [bDate, bTime] = b.created_on?.split(' ');
        if (aDate > bDate) return -1;
        if (aDate < bDate) return 1;
        const [aHours, aMinutes, aSeconds, aMilliseconds] =
          aTime?.split(/[:.]/);
        const [bHours, bMinutes, bSeconds, bMilliseconds] =
          bTime?.split(/[:.]/);
        const aTimeValue =
          parseInt(aHours, 10) * 3600000 +
          parseInt(aMinutes, 10) * 60000 +
          parseInt(aSeconds, 10) * 1000 +
          parseInt(aMilliseconds, 10);
        const bTimeValue =
          parseInt(bHours, 10) * 3600000 +
          parseInt(bMinutes, 10) * 60000 +
          parseInt(bSeconds, 10) * 1000 +
          parseInt(bMilliseconds, 10);
        return bTimeValue - aTimeValue;
      });
      setBookingsList(list);
    } else {
      setBookingsList([]);
    }
    clearSessionStorage();
    setIsLoading(false);
  };
  const getEsimTransactionsLIst = async () => {
    setIsLoading(true);
    const data = await getEsimTransactionsApi(
      formatDate(searchCriteria.fromDate, API_DATE_FORMAT),
      formatDate(searchCriteria.toDate, API_DATE_FORMAT),
    );
    setBookingsList(data);
    clearSessionStorage();
    setIsLoading(false);
  };

  const handleGetBookings = async (txType) => {
    if (searchCriteria.fromDate > searchCriteria.toDate) {
      setAlert({
        variant: 'error',
        title: 'My Bookings',
        description: 'From Date should not be greater than To Date',
      });
      return;
    }

    switch (txType) {
      case 'flightBookings':
        await getFlightBookingList();
        break;
      case 'hotelBookings':
        await getHotelBookingList();
        break;
      case 'hotelCancellations':
        await getHotelCancellationList();
        break;
      case 'flightcancellations':
        await getFligthCancellationsList();
        break;
      case 'flightcancellationsqueues':
        await getFligthCancellationsQueuesList();
        break;
      case 'flightreshedules':
        await getFlightReschedulesList();
        break;
      case 'flightholdqueues':
        await getFlightHoldQueuesList();
        break;
      case 'creditnotes':
        await getCreditNoteList();
        break;
      case 'debitnotes':
        await getDebitNoteList();
        break;
      case 'fundtransfers':
        await getFundTransfersList();
        break;
      case 'fundreversals':
        await getFundReversalsList();
        break;
      case 'topupreceipts':
        await getTopupReceiptsList();
        break;
      case 'ssrHistory':
        await getSsrHistoryList();
        break;
      case 'busBookings':
        await getBusBookingList();
        break;
      case 'busCancellations':
        await getBusCancellationList();
        break;
      case 'insuranceBookings':
        await getInsuranceBookingsList();
        break;
      case 'visaBookings':
        await getVisaBookingsList();
        break;
      case 'eSimbookings':
        await getEsimTransactionsLIst();
        break;
      default:
        await getFlightBookingList();
        break;
    }
  };

  useEffect(() => {
    const resolvedTxType =
      isEmpty(searchParams.get(TRANSACTION_TYPE)) ||
      FULL_TX_LIST.findIndex(
        (x) => x.value === searchParams.get(TRANSACTION_TYPE),
      ) === -1
        ? appConfig?.hasFlight
          ? 'flightBookings'
          : FULL_TX_LIST[0].value
        : searchParams.get(TRANSACTION_TYPE);

    setActiveCategory(TX_TYPE_CATEGORY[resolvedTxType] || activeCategory);
    setBookingsList([]);
    setSearchCriteria({
      ...searchCriteria,
      transactionType: resolvedTxType,
    });
    handleGetBookings(resolvedTxType);
  }, [searchParams]);

  const handleUpdateSearchState = (name, value) => {
    if (name === 'transactionType') {
      sessionStorage.setItem(SESSION_KEY_EMPTY, true);
      const fromSource = searchParams.get('source');
      if (fromSource) {
        setSearchParams({
          ...searchParams,
          transactionType: value,
          source: fromSource,
        });
      } else {
        setSearchParams({
          ...searchParams,
          transactionType: value,
        });
      }
    }

    setSearchCriteria((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDateChange = (name, date) => {
    handleUpdateSearchState(name, date);
  };

  const handleTxTypeChange = (txType, category) => {
    if (category) setActiveCategory(category);
    handleUpdateSearchState('transactionType', txType);
    setBookingsList(undefined);
  };

  return (
    <section className="my-bookings-page">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <AccountsPageHorizontalBar selectedPage="my-bookings" />
      <div className="my-bookings-page_container mb-3">
        <div className="my-bookings-page_search-container gap-1">
          <div className="my-bookings-page_search-container_icon-container fs-4 grey-color ">
            {appConfig.hasFlight && (
              <AppIconButton
                variant="transparent"
                onClick={() => handleTxTypeChange('flightBookings', 'flight')}
                className={
                  searchCriteria.transactionType === 'flightBookings'
                    ? 'selected-app-icon-btn'
                    : 'app-icon-btn'
                }
              >
                <LuPlane />
              </AppIconButton>
            )}
            {appConfig.hasHotel && (
              <AppIconButton
                variant="transparent"
                onClick={() => handleTxTypeChange('hotelBookings', 'hotel')}
                className={
                  searchCriteria.transactionType === 'hotelBookings'
                    ? 'selected-app-icon-btn'
                    : 'app-icon-btn'
                }
              >
                <LuBedDouble />
              </AppIconButton>
            )}
            {appConfig.hasBus && (
              <AppIconButton
                variant="transparent"
                onClick={() => handleTxTypeChange('busBookings', 'bus')}
                className={
                  searchCriteria.transactionType === 'busBookings'
                    ? 'selected-app-icon-btn'
                    : 'app-icon-btn'
                }
              >
                <LuBus />
              </AppIconButton>
            )}
            {appConfig.hasInsurance && (
              <AppIconButton
                variant="transparent"
                onClick={() =>
                  handleTxTypeChange('insuranceBookings', 'insurance')
                }
                className={
                  searchCriteria.transactionType === 'insuranceBookings'
                    ? 'selected-app-icon-btn'
                    : 'app-icon-btn'
                }
              >
                <LuShieldCheck />
              </AppIconButton>
            )}{' '}
            {appConfig.hasEsimfast && (
              <AppIconButton
                variant="transparent"
                onClick={() => handleTxTypeChange('eSimbookings', 'esim')}
                className={
                  searchCriteria.transactionType === 'eSimbookings'
                    ? 'selected-app-icon-btn'
                    : 'app-icon-btn'
                }
              >
                <BsSim />
              </AppIconButton>
            )}{' '}
            {appConfig.hasOnlineVisa && (
              <AppIconButton
                variant="transparent"
                onClick={() => handleTxTypeChange('visaBookings', 'visa')}
                className={
                  searchCriteria.transactionType === 'visaBookings'
                    ? 'selected-app-icon-btn'
                    : 'app-icon-btn'
                }
              >
                <LiaCcVisa />
              </AppIconButton>
            )}
          </div>
          <div className="my-bookings-page_search-container_date-container gap-2 ">
            {!isMobileWidth() && (
              <div>
                <AppSelect
                  name="transactionType"
                  className="app-select fs-14"
                  selectWidth={isMobileWidth() ? '100%' : '200px'}
                  placeholder=""
                  label="Other tx type"
                  selectedValue={
                    TRANSACTION_TYPES.some(
                      (tx) => tx.value === searchCriteria.transactionType,
                    ) === true
                      ? searchCriteria.transactionType
                      : ''
                  }
                  options={TRANSACTION_TYPES}
                  onSelect={(dataObj, name) => {
                    handleUpdateSearchState(name, dataObj.value);
                  }}
                  isClearable={false}
                />
              </div>
            )}
            <div className="d-flex gap-2">
              <div className="flex-1">
                <AppDatePicker
                  selectedDate={searchCriteria.fromDate}
                  customClassName="my-bookings-page_date-picker"
                  labelClassName="my-bookings-page_date-label"
                  type="date"
                  name="fromDate"
                  showMonthDropdown={isMobileWidth()}
                  showYearDropdown={isMobileWidth()}
                  dropdownMode={isMobileWidth() ? 'select' : ''}
                  disabledKeyboardNavigation={isMobileWidth()}
                  placeholder=""
                  label={formattedMessage('from_date')}
                  onChange={(date) => handleDateChange('fromDate', date)}
                />
              </div>
              <div className="flex-1">
                <AppDatePicker
                  selectedDate={searchCriteria.toDate}
                  customClassName="my-bookings-page_date-picker"
                  labelClassName="my-bookings-page_date-label"
                  type="date"
                  name="toDate"
                  placeholder=""
                  showMonthDropdown={isMobileWidth()}
                  showYearDropdown={isMobileWidth()}
                  dropdownMode={isMobileWidth() ? 'select' : ''}
                  disabledKeyboardNavigation={isMobileWidth()}
                  label={formattedMessage('to_date')}
                  onChange={(date) => handleDateChange('toDate', date)}
                />
              </div>
            </div>
            <div className="d-flex gap-1">
              {isMobileWidth() && (
                <AppSelect
                  name="transactionType"
                  className="app-select fs-14"
                  appSelectClassName="flex-1"
                  selectWidth={isMobileWidth() ? '100%' : '200px'}
                  placeholder=""
                  label="Other tx type"
                  selectedValue={
                    TRANSACTION_TYPES.some(
                      (tx) => tx.value === searchCriteria.transactionType,
                    ) === true
                      ? searchCriteria.transactionType
                      : ''
                  }
                  options={TRANSACTION_TYPES}
                  onSelect={(dataObj, name) => {
                    handleUpdateSearchState(name, dataObj.value);
                  }}
                  isClearable={false}
                />
              )}
              <AppButton
                variant="secondary"
                btnText={formattedMessage('go_btn')}
                onClick={() =>
                  handleGetBookings(searchCriteria.transactionType)
                }
              />
            </div>
          </div>
        </div>
      </div>
      <section className="app-container">
        {bookingsList && bookingsList.length === 0 && (
          <div className="my-bookings-page__booking">
            <span className="my-bookings-page__booking_header__trip-info text-center kkk">
              {formattedMessage('no_booking_records_alert')}
            </span>
          </div>
        )}
      </section>
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        (searchParams.get(TRANSACTION_TYPE) === 'flightBookings' ||
          searchParams.get(TRANSACTION_TYPE) === null) && (
          <FlightBookingList flightBookings={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'flightcancellations' && (
          <FlightCancellationList flightCancellations={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'flightreshedules' && (
          <FlightRescheduleList flightReschedules={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'flightholdqueues' && (
          <FlightHoldQueueList flightHoldQueues={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'creditnotes' && (
          <CreditDebitList creditDebitList={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'busBookings' && (
          <BusBookingList busBookings={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'debitnotes' && (
          <CreditDebitList creditDebitList={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'fundtransfers' && (
          <CreditDebitList creditDebitList={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'fundreversals' && (
          <CreditDebitList creditDebitList={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'topupreceipts' && (
          <TopupReceiptList topupReceiptList={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'hotelBookings' && (
          <BookingsList hotelBookings={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'hotelCancellations' && (
          <HotelCancellationList cancellationList={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'busCancellations' && (
          <BusCancellationList busCancellations={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'insuranceBookings' && (
          <InsuranceBookingsList insuranceBookings={bookingsList} />
        )}{' '}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'flightcancellationsqueues' && (
          <FlightCancellationQueuesList flightCancellations={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'visaBookings' && (
          <VisaBookingList visaBookings={bookingsList} />
        )}
      {bookingsList &&
        bookingsList.length > 0 &&
        sessionStorage.getItem(SESSION_KEY_EMPTY) === null &&
        searchParams.get(TRANSACTION_TYPE) === 'eSimbookings' && (
          <EsimTransactionsList visaBookings={bookingsList} />
        )}
    </section>
  );
}

export default MyBookingPage;
